var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictoSurface(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "picto_surface_-_biens_vendus",
    "data-name": "picto surface - biens vendus",
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.887,
    height: 17.887,
    viewBox: "0 0 17.887 17.887",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_64",
    "data-name": "Trac\\xE9 64",
    d: "M110.232,2.577a.282.282,0,0,0,.3-.3V.789h.3a.282.282,0,0,0,.3-.3.282.282,0,0,0-.3-.3h-.3V-.7a.282.282,0,0,0-.3-.3.282.282,0,0,0-.3.3V2.279A.282.282,0,0,0,110.232,2.577Z",
    transform: "translate(-106.061 1)",
    fill: "#616a7d"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_65",
    "data-name": "Trac\\xE9 65",
    d: "M85.391,119.367a.245.245,0,0,0,.259-.259V114.96h.778a.285.285,0,0,0,.259-.156.293.293,0,0,0-.078-.285l-3.914-3.5a1.779,1.779,0,0,0-2.359,0l-3.914,3.5a.309.309,0,0,0-.078.285.263.263,0,0,0,.233.156h.778v4.148a.245.245,0,0,0,.259.259h7.777Z",
    transform: "translate(-72.586 -106.175)",
    fill: "none",
    stroke: "#2c3852",
    strokeWidth: 1,
    opacity: 0.75
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_66",
    "data-name": "Trac\\xE9 66",
    d: "M411.88,366.53h-.894v-.3a.3.3,0,0,0-.6,0v.3H408.9a.3.3,0,1,0,0,.6h2.981a.3.3,0,1,0,0-.6Z",
    transform: "translate(-394.293 -353.115)",
    fill: "#616a7d"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_67",
    "data-name": "Trac\\xE9 67",
    d: "M76.4,459.8h-.3a.3.3,0,0,0,0,.6h.3a.3.3,0,0,0,0-.6Z",
    transform: "translate(-73.119 -443.701)",
    fill: "#616a7d"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_68",
    "data-name": "Trac\\xE9 68",
    d: "M119.063,459.8h-.3a.3.3,0,0,0,0,.6h.3a.3.3,0,0,0,0-.6Z",
    transform: "translate(-114.295 -443.701)",
    fill: "#616a7d"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_69",
    "data-name": "Trac\\xE9 69",
    d: "M161.73,459.8h-.3a.3.3,0,1,0,0,.6h.3a.3.3,0,1,0,0-.6Z",
    transform: "translate(-155.471 -443.701)",
    fill: "#616a7d"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_70",
    "data-name": "Trac\\xE9 70",
    d: "M204.4,459.8h-.3a.3.3,0,1,0,0,.6h.3a.3.3,0,0,0,0-.6Z",
    transform: "translate(-196.646 -443.701)",
    fill: "#616a7d"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_71",
    "data-name": "Trac\\xE9 71",
    d: "M247.063,459.8h-.3a.3.3,0,0,0,0,.6h.3a.3.3,0,1,0,0-.6Z",
    transform: "translate(-237.822 -443.701)",
    fill: "#616a7d"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_72",
    "data-name": "Trac\\xE9 72",
    d: "M289.73,459.8h-.3a.3.3,0,0,0,0,.6h.3a.3.3,0,0,0,0-.6Z",
    transform: "translate(-278.998 -443.701)",
    fill: "#616a7d"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_73",
    "data-name": "Trac\\xE9 73",
    d: "M332.4,459.8h-.3a.3.3,0,0,0,0,.6h.3a.3.3,0,0,0,0-.6Z",
    transform: "translate(-320.176 -443.701)",
    fill: "#616a7d"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_74",
    "data-name": "Trac\\xE9 74",
    d: "M375.063,459.8h-.3a.3.3,0,0,0,0,.6h.3a.3.3,0,0,0,0-.6Z",
    transform: "translate(-361.35 -443.701)",
    fill: "#616a7d"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_75",
    "data-name": "Trac\\xE9 75",
    d: "M417.73,459.8h-.3a.3.3,0,0,0,0,.6h.3a.3.3,0,0,0,0-.6Z",
    transform: "translate(-402.527 -443.701)",
    fill: "#616a7d"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_76",
    "data-name": "Trac\\xE9 76",
    d: "M461.292,459.8H460.1a.282.282,0,0,0-.3.3v1.192a.3.3,0,0,0,.6,0V460.4h.894a.3.3,0,1,0,0-.6Z",
    transform: "translate(-443.703 -443.701)",
    fill: "#616a7d"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_77",
    "data-name": "Trac\\xE9 77",
    d: "M417.432,33.73h.3a.3.3,0,1,0,0-.6h-.3a.3.3,0,1,0,0,.6Z",
    transform: "translate(-402.527 -31.941)",
    fill: "#616a7d"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_78",
    "data-name": "Trac\\xE9 78",
    d: "M374.765,33.73h.3a.3.3,0,0,0,0-.6h-.3a.3.3,0,0,0,0,.6Z",
    transform: "translate(-361.35 -31.941)",
    fill: "#616a7d"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_79",
    "data-name": "Trac\\xE9 79",
    d: "M332.1,33.73h.3a.3.3,0,0,0,0-.6h-.3a.3.3,0,0,0,0,.6Z",
    transform: "translate(-320.174 -31.941)",
    fill: "#616a7d"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_80",
    "data-name": "Trac\\xE9 80",
    d: "M289.432,33.73h.3a.3.3,0,0,0,0-.6h-.3a.3.3,0,1,0,0,.6Z",
    transform: "translate(-278.998 -31.941)",
    fill: "#616a7d"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_81",
    "data-name": "Trac\\xE9 81",
    d: "M246.765,33.73h.3a.3.3,0,1,0,0-.6h-.3a.3.3,0,0,0,0,.6Z",
    transform: "translate(-237.822 -31.941)",
    fill: "#616a7d"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_82",
    "data-name": "Trac\\xE9 82",
    d: "M204.1,33.73h.3a.3.3,0,1,0,0-.6h-.3a.3.3,0,0,0,0,.6Z",
    transform: "translate(-196.646 -31.941)",
    fill: "#616a7d"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_83",
    "data-name": "Trac\\xE9 83",
    d: "M161.432,33.73h.3a.3.3,0,1,0,0-.6h-.3a.3.3,0,1,0,0,.6Z",
    transform: "translate(-155.471 -31.941)",
    fill: "#616a7d"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_84",
    "data-name": "Trac\\xE9 84",
    d: "M67.863,33.73a.3.3,0,1,0,0-.6h-.3a.3.3,0,0,0,0,.6Z",
    transform: "translate(-64.883 -31.941)",
    fill: "#616a7d"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_85",
    "data-name": "Trac\\xE9 85",
    d: "M460.1.79h1.192a.282.282,0,0,0,.3-.3.282.282,0,0,0-.3-.3H460.4V-.7a.282.282,0,0,0-.3-.3.282.282,0,0,0-.3.3V.492A.282.282,0,0,0,460.1.79Z",
    transform: "translate(-443.703 0.999)",
    fill: "#616a7d"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_86",
    "data-name": "Trac\\xE9 86",
    d: "M.491-1a.282.282,0,0,0-.3.3V.192H-.7a.282.282,0,0,0-.3.3.282.282,0,0,0,.3.3H.491a.282.282,0,0,0,.3-.3V-.7A.282.282,0,0,0,.491-1Z",
    transform: "translate(1 1)",
    fill: "#616a7d"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_87",
    "data-name": "Trac\\xE9 87",
    d: "M33.432,75.8a.282.282,0,0,0-.3.3v.3a.3.3,0,1,0,.6,0v-.3A.282.282,0,0,0,33.432,75.8Z",
    transform: "translate(-31.943 -73.117)",
    fill: "#616a7d"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_88",
    "data-name": "Trac\\xE9 88",
    d: "M33.432,118.467a.282.282,0,0,0-.3.3v.3a.3.3,0,0,0,.6,0v-.3A.282.282,0,0,0,33.432,118.467Z",
    transform: "translate(-31.943 -114.293)",
    fill: "#616a7d"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_89",
    "data-name": "Trac\\xE9 89",
    d: "M33.432,161.133a.282.282,0,0,0-.3.3v.3a.3.3,0,1,0,.6,0v-.3A.282.282,0,0,0,33.432,161.133Z",
    transform: "translate(-31.943 -155.469)",
    fill: "#616a7d"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_90",
    "data-name": "Trac\\xE9 90",
    d: "M33.432,203.8a.282.282,0,0,0-.3.3v.3a.3.3,0,1,0,.6,0v-.3A.282.282,0,0,0,33.432,203.8Z",
    transform: "translate(-31.943 -196.645)",
    fill: "#616a7d"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_91",
    "data-name": "Trac\\xE9 91",
    d: "M33.432,246.467a.282.282,0,0,0-.3.3v.3a.3.3,0,1,0,.6,0v-.3A.282.282,0,0,0,33.432,246.467Z",
    transform: "translate(-31.943 -237.822)",
    fill: "#616a7d"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_92",
    "data-name": "Trac\\xE9 92",
    d: "M33.432,289.133a.282.282,0,0,0-.3.3v.3a.3.3,0,0,0,.6,0v-.3A.282.282,0,0,0,33.432,289.133Z",
    transform: "translate(-31.943 -278.997)",
    fill: "#616a7d"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_93",
    "data-name": "Trac\\xE9 93",
    d: "M33.432,331.8a.282.282,0,0,0-.3.3v.3a.3.3,0,0,0,.6,0v-.3A.282.282,0,0,0,33.432,331.8Z",
    transform: "translate(-31.943 -320.173)",
    fill: "#616a7d"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_94",
    "data-name": "Trac\\xE9 94",
    d: "M33.432,374.467a.282.282,0,0,0-.3.3v.3a.3.3,0,0,0,.6,0v-.3A.282.282,0,0,0,33.432,374.467Z",
    transform: "translate(-31.943 -361.35)",
    fill: "#616a7d"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_95",
    "data-name": "Trac\\xE9 95",
    d: "M33.432,417.133a.282.282,0,0,0-.3.3v.3a.3.3,0,0,0,.6,0v-.3A.282.282,0,0,0,33.432,417.133Z",
    transform: "translate(-31.943 -402.525)",
    fill: "#616a7d"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_96",
    "data-name": "Trac\\xE9 96",
    d: "M460.1,68.161a.282.282,0,0,0,.3-.3v-.3a.3.3,0,0,0-.6,0v.3A.282.282,0,0,0,460.1,68.161Z",
    transform: "translate(-443.703 -64.882)",
    fill: "#616a7d"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_97",
    "data-name": "Trac\\xE9 97",
    d: "M460.1,110.828a.282.282,0,0,0,.3-.3v-.3a.3.3,0,1,0-.6,0v.3A.282.282,0,0,0,460.1,110.828Z",
    transform: "translate(-443.703 -106.059)",
    fill: "#616a7d"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_98",
    "data-name": "Trac\\xE9 98",
    d: "M460.1,153.5a.282.282,0,0,0,.3-.3v-.3a.3.3,0,1,0-.6,0v.3A.282.282,0,0,0,460.1,153.5Z",
    transform: "translate(-443.703 -147.235)",
    fill: "#616a7d"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_99",
    "data-name": "Trac\\xE9 99",
    d: "M460.1,196.161a.282.282,0,0,0,.3-.3v-.3a.3.3,0,0,0-.6,0v.3A.282.282,0,0,0,460.1,196.161Z",
    transform: "translate(-443.703 -188.41)",
    fill: "#616a7d"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_100",
    "data-name": "Trac\\xE9 100",
    d: "M460.1,238.828a.282.282,0,0,0,.3-.3v-.3a.3.3,0,1,0-.6,0v.3A.282.282,0,0,0,460.1,238.828Z",
    transform: "translate(-443.703 -229.586)",
    fill: "#616a7d"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_101",
    "data-name": "Trac\\xE9 101",
    d: "M460.1,281.5a.282.282,0,0,0,.3-.3v-.3a.3.3,0,0,0-.6,0v.3A.282.282,0,0,0,460.1,281.5Z",
    transform: "translate(-443.703 -270.763)",
    fill: "#616a7d"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_102",
    "data-name": "Trac\\xE9 102",
    d: "M460.1,324.161a.282.282,0,0,0,.3-.3v-.3a.3.3,0,1,0-.6,0v.3A.282.282,0,0,0,460.1,324.161Z",
    transform: "translate(-443.703 -311.938)",
    fill: "#616a7d"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_103",
    "data-name": "Trac\\xE9 103",
    d: "M460.1,418.028a.282.282,0,0,0,.3-.3v-.3a.3.3,0,0,0-.6,0v.3A.282.282,0,0,0,460.1,418.028Z",
    transform: "translate(-443.703 -402.526)",
    fill: "#616a7d"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_104",
    "data-name": "Trac\\xE9 104",
    d: "M.491,459.8H-.7a.282.282,0,0,0-.3.3.282.282,0,0,0,.3.3H.192v.894a.282.282,0,0,0,.3.3.282.282,0,0,0,.3-.3V460.1A.282.282,0,0,0,.491,459.8Z",
    transform: "translate(1 -443.701)",
    fill: "#616a7d"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictoSurface);
export default __webpack_public_path__ + "static/media/picto_surface.20caea71.svg";
export { ForwardRef as ReactComponent };